import {combineReducers} from 'redux';
import {authReducers} from './_auth/auth.reducers';
import {newReportReducers} from 'pages/new-report/store';
import {myReportsReducers} from 'pages/my-report/store';
import {homeReducers} from 'pages/home/store';

const index = combineReducers({
    authReducers,
    newReportReducers,
    myReportsReducers,
    homeReducers
});

export default index;
